// extracted by mini-css-extract-plugin
export default {"wrap":"uI-z","subtitle":"vI-z","contentWrap":"wI-z","imgWrap":"xI-z","heading":"yI-z","copy":"zI-z"};